import React from "react";
import { Image, TouchableWithoutFeedback, View} from 'react-native';
const backArrow = require('./../../assets/left-arrow2.png');
const orangeArrow = require('./../../assets/leftarrow.png');

const BackButtonImage = (props) => {
    const {style, onPress, source, color,iconChange} = props;
    const images = !iconChange ? backArrow : orangeArrow
  
    return(
        <TouchableWithoutFeedback
          onPress={() => {
              if(typeof onPress === 'function') {
                onPress()
              }
          }}
        
          {...props}
        >
             <View
                style={{ paddingLeft: 10, paddingRight: 20,  marginHorizontal:10, width:50, height:50, justifyContent:'center', alignItems:'center', ...style}}
             >
                 <Image style={{paddingLeft: 10, paddingRight: 20, marginHorizontal:10,  width:16, height:16, justifyContent:'center', color:color }} source={images} />
             </View>
        </TouchableWithoutFeedback>
    )
}
export default BackButtonImage;